<template>
    <div>
<div class="row">
    <div class="col-lg-12 col-md-12">
        <div class="card panel ">
            <div class="card-header headnbtn">
                <div class="d-flex align-items-center justify-content-between">
                    <h5 class="card-title mb-0 flex-grow-1">List of Product</h5>
                    <!--<div class="flex-shrink-0">
                        <a href="#" class="btn btn-primary btn-sm" id="qfilter"><i class="ri-filter-line align-middle me-1"></i> Filter</a>
                    </div>-->
                </div>
            </div>
            <div class="card-body p-0">
                <div class="table-responsive product-create ">
                    <table class="table table-nowrap table-bordered align-middle table-custom mb-0">
                        <thead>
                        <tr>
                            <th>Product No</th>
                            <th>Product Name</th>
                            <th>Customer</th>
                            <th style="width: 120px">Selling Price</th>
                            <th style="width: 120px">Vendor Cost</th>
                            <th>Status</th>
                            <th style="width: 120px">Action </th>
                        </tr>
                        </thead>
                        <template v-if="customerData.data.length > 0">
                            <template  v-for="(customer, index) in customerData.data">
                                <tr :id="customer.id">
                                    <td>{{customer.product_num}}</td>
                                    <td>{{customer.product_name}}</td>
                                    <td>{{customer.customer ? customer.customer.company_name : ""}}</td>
                                    <td>${{customer.selling}}</td>
                                    <td>${{customer.vendor_cost}}</td>
                                    <td><a href="#" :class="[customer.status=='1' ? 'btn active-btn':'btn inactive-btn']" >{{(customer.status=='1')?'Active':'Inactive'}}</a></td>
                                    <td>
                                        <router-link
                                                    :to="{name: 'productsDetails', params: {id: customer.id}}"
                                                    class="btn view-btn" title="Details Product" :data-id="customer.id">
                                                    <i class="ri-eye-line"></i></router-link>
                                        
                                        <a href="javascript:void(0);" @click="openEditProductModal(customer.id)" class="edit_btn" title="Edit Product" :data-id="customer.id"><i class="ri-edit-fill me-1"></i></a>
                                                    
                                        <!-- <router-link
                                                    :to="{name: 'editProducts', params: {id: customer.id}}"
                                                    class="edit_btn" title="Edit Product" :data-id="customer.id"><i class="ri-edit-fill me-1"></i></router-link> -->
                                                    <!-- class="edit_btn" title="Edit Customer" :data-id="customer.id"><i class="fas fa-pencil-alt"></i></router-link> -->
                                        <!-- <a  href="javascript:void(0);" @click="showDelete(customer.id)" class="del_btn" title="Delete Customer" :data-id="customer.id"><i class="fas fa-trash-alt"></i></a> -->
                                    </td>
                                </tr>
                            </template>
                        </template>
                        <template v-else>
                            <tr><td colspan="8" style="text-align:center;">No records found</td></tr>
                        </template>
                    </table>

                    <div class="btnrow text-left">
                        <div class="overflow-auto mb-3">
                            <b-pagination
                                v-model="current_page"
                                :total-rows="total"
                                :per-page="per_page"
                            ></b-pagination>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>


</div>

<ProductEditModal @productDataSaved="customerDataSaved($event)" :options="optionvs" :optionsCustomer="optionsCustomer" :form_new="form"></ProductEditModal>

    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import ProductEditModal from "./ProductEditModal";
export default {
    name: "ProductList",
    components: {
            ProductEditModal
        },
    props: ['bus','status_filter','customer_filter','product_number','product_name','product_description','customer_sku'],
    created() {
        if(localStorage.getItem('token')){
            console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.setSuccessMessage(null);
        this.getCustomers();
    },
    mounted() {
        if(this.status_filter) {
            this.filterForm.status_filter = this.status_filter;
            alert("ddd");
        }
         if(this.customer_filter) {
            this.filterForm.customer_filter = this.customer_filter;
            alert("ddd");
        }

        if(this.name) {
            this.filterForm.name = this.name;
            alert("ddd");
        }

        if(this.description) {
            this.filterForm.description = this.description;
            alert("ddd");
        }
        

        this.bus.$on('getCustomers', this.getCustomers)
        this.bus.$on('productDataSaved', this.getCustomers)
    },
    data(){
        return {
            selected:[],
            options:[
                // { label: 'Select More Column', id: 0 },
                { label: 'General phone number', id: 1 },
                { label: 'Billing email', id: 2 },
                { label: 'Total number of quotes', id: 3 },
                { label: 'Total number of orders', id: 4 },
            ],
            optionvs:[],
            optionsCustomer:[],

            customerData:{
                data:[]
            },
            current_page:1,
            per_page:10,
            total:0,
            filterForm: {
                search_filter: null,
                status_filter: '',
                customer_filter:null,
                product_number:null,
                product_name:null,
                product_description:null,
                customer_sku:null,
            },
            showModal: false,
            deleteId: null,
            csv_file: null,
            uploadPercent: 0,
            showUploadProgress: false,
            processingUpload: false,
            productId:null,
            form: {
                id:null,
                qty_unit_id:null,
                product_name: null,
                price: null,
                product_desc: null,
                product_num: null,
                vendor_id: null,
                customer_id: null,
                selling: null,
                status:"1",
                vendor_cost:null,
                sku: null,
                customer_sku: null,
            },
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        // updatePagination(){
        //     if(this.current_page != 1){
        //         this.getCustomers();
        //     }
        // },
        customerDataSaved(updatedProduct){
            this.getCustomers();
        },
        openEditProductModal(productId){
            this.productId = productId;
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            //this.setSuccessMessage(null);
            return axios.get(window.route('products.show', {id: productId}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                       // this.customerData = data.data;
                        console.log("this.customerData 11",data);
                         this.form = {
                            id: data.data.id,
                            qty_unit_id:data.data.unit_id,
                            product_name: data.data.product_name,
                            product_desc: data.data.product_desc,
                            price: data.data.price,
                            product_num: data.data.product_num,
                            vendor_id: data.data.vendor_id,
                            customer_id: data.data.customer_id,
                            selling: data.data.selling,
                            status:data.data.status,
                            vendor_cost:data.data.vendor_cost,
                             sku: data.data.sku,
                             customer_sku: data.data.customer_sku,
                         }
                         if(data.data.vendor){
                            this.optionvs = [
                                {
                                id:data.data.vendor.id,
                                company_name:data.data.vendor.company_name
                                }
                            ];
                         }
                         if(data.data.customer){
                            this.optionsCustomer = [
                                {
                                id:data.data.customer.id,
                                company_name:data.data.customer.company_name
                                }
                            ];
                         }

                        console.log("this.form ",this.form );
                        console.log("this.optionvs ",this.optionvs );
                         $('#productEditModal').modal('show');


                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });

            
        },
        getCustomers() {
            console.log("dddd",this.filterForm);
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('products.index',{page: this.current_page,search_filter:this.filterForm.search_filter,status_filter:this.filterForm.status_filter,customer_filter:this.filterForm.customer_filter,
                product_number:this.filterForm.product_number,product_name:this.filterForm.product_name,product_description:this.filterForm.product_description,customer_sku:this.filterForm.customer_sku
            } ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {

                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage != null){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerData = data.data;
                        this.current_page = data.data.current_page;
                        this.per_page = data.data.per_page;
                        this.total = data.data.total;
                        //this.setCustomers(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getSLNo(index) {
            return index;
        },
        handleFileUpload(){
            this.csv_file = this.$refs.csv_file.files[0];
        },
        showDelete(id) {
            this.deleteId = id;
            $('#deleteModal').modal('show');
        },
        hideDelete() { $('#deleteModal').modal('hide'); this.deleteId = null; },
        deleteCustomer() {
            if(this.deleteId) {
                let self = this;
                this.setCustomerLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.delete(window.route('customers.destroy', {id: this.deleteId}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({ data }) => {
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        } else if(data.errorMessage){
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            setTimeout(() => {
                                self.setSuccessMessage(null);
                            }, 5000);
                            self.deleteId = null;
                            self.getCustomers();
                            $('#deleteModal').modal('hide');
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setCustomerLoading(false);

                    });
            }
        }
    },
    watch: {
        current_page: {
            handler: function(value) {
                    this.getCustomers();
                console.log("watch ",value);
                // this.fetchData().catch(error => {
                // console.error(error)
                // })
            }
        },
        selected: {
            handler: function(selectedVal) {
                this.getCustomers();
                console.log("watch ",selectedVal);

            }
        },
        product_number: {
            handler: function (value) {
                this.filterForm.product_number = value;
            }
        },
        product_name: {
            handler: function (value) {
                this.filterForm.product_name = value;
            }
        },
        product_description: {
            handler: function (value) {
                this.filterForm.product_description = value;
            }
        },
        customer_sku: {
            handler: function (value) {
                this.filterForm.customer_sku = value;
            }
        },
        customer_filter: {
            handler: function (value) {
                this.filterForm.customer_filter = value;
            }
        },
        status_filter: {
            handler: function (value) {
                this.filterForm.status_filter = value;
            }
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
.select2-selection {
    border-radius: 0px !important;
    text-align: left !important;
}
.select2-dropdown {
    border-radius: 0px !important;
}
</style>
